import ProductCard from "./ProductCard";

export default function ProductFeed({ products, loading }) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 gap-x-4 gap-y-10 px-4" data-testid="feed-loading">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="animate-pulse">
            <div className="aspect-[3/4] bg-[#F0EBE2]" />
            <div className="h-4 bg-[#F0EBE2] mt-4 mx-8" />
            <div className="h-3 bg-[#F0EBE2] mt-2 mx-14" />
          </div>
        ))}
      </div>
    );
  }

  if (!products.length) {
    return (
      <p className="text-center text-sm tracking-wide text-[#8B8578] py-16 px-6" data-testid="feed-empty">
        Nessun capo disponibile in questa categoria al momento.
      </p>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-10 px-4 sm:gap-x-6 sm:gap-y-14" data-testid="product-feed">
      {products.map((p) => (
        <ProductCard key={p.id} product={p} />
      ))}
    </div>
  );
}
